import {Card, Stack, Table, TableBody, TableCell, TableHead, TableRow, Typography} from "@mui/material";
import PropTypes from "prop-types";

SessionScheduleCategory.propTypes = {
    categoryName: PropTypes.string.isRequired,
    disciplines: PropTypes.array.isRequired,
    groups: PropTypes.array.isRequired
}

export default function SessionScheduleCategory(props) {
    return <>
        <Typography variant={"h5"}>{props.categoryName}</Typography>
        <Card>
            <Stack spacing={2}>
                <Table size={"small"}>
                    <TableHead>
                        <TableRow>
                            <TableCell rowSpan={2}>Наименование дисциплины</TableCell>
                            <TableCell rowSpan={2}>Ф.И.О. экзаменатора</TableCell>
                            <TableCell align={"center"} colSpan={props.groups?.length ?? 1}>Группа</TableCell>
                        </TableRow>
                        <TableRow>
                            {props.groups.map((g) => {
                                return <TableCell align={"center"}>{g}</TableCell>
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.disciplines?.map((item) => {
                            return <TableRow>
                                <TableCell>{item.disciplineName}</TableCell>
                                <TableCell>
                                    {item.employees.join(', ')}
                                    {item.extraEmployees.length > 0 
                                        ? <><br />{item.extraEmployees.join(', ')}</> 
                                        : <></>}
                                </TableCell>

                                {props.groups?.map((g) => {
                                    const group = item.groups.find(group => group.groupName === g);
                                    return <TableCell align={"center"}>
                                        {group
                                        ? <>{group.eventDate}<br />{group.eventPlace}</>
                                        : <>-</>}
                                    </TableCell>
                                })}
                            </TableRow>
                        })}
                    </TableBody>
                </Table>
            </Stack>
        </Card>
    </>
}